import { RightOutlined } from '@ant-design/icons';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Domains from '@lcsc-ui/utils/domains';
import { styled } from 'styled-components';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const CustomSwiperStyle = styled.div`
  .swiper {
    padding: 23px 0 49px 0;
  }
  .swiper-pagination {
    bottom: 12px;
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #0093e6;
    }
  }
`;

const pagination = {
  clickable: true,
};

const TopSection = ({ title, dataList, isLgScreen }) => {
  const wwwUrl = Domains.lcscWwwUrl;
  const flag = title === '推荐供应商' ? 'supplier' : 'recommend';
  const spmFlag = title === '推荐供应商' ? 'gys' : 'xp';
  const moreHref = `${wwwUrl}/${flag}/list.html`;
  const buriedOp = title === '推荐供应商' ? 'recommended_supplier' : 'new_products';
  function _buriedPoint() {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'index',
      op: buriedOp,
    });
  }
  if (dataList && dataList.length) {
    const listDom = dataList.slice(1, isLgScreen ? 10 : 9).map((news, idx) => (
      <li key={idx} className={`flex items-center ${idx !== 9 ? 'mb-[9px]' : 'mb-0'}`}>
        <span className={`text-[16px] font-bold w-[20px] ${idx < 3 ? 'text-[#F3543D]' : 'text-[#56657F]'}`}>
          {idx + 1}
        </span>
        <a
          href={`${wwwUrl}/info/${news.informationId}.html`}
          data-spm={idx + 2}
          target="_blank"
          className={`text-[14px] w-[200px] _lg:w-[300px] h-[20px] mr-[10px] truncate ${idx < 4 ? 'text-black' : 'text-[#666]'} hover:text-lcBlue antialiased`}
          title={news.title}
        >
          {news.title}
        </a>
        <div className="flex-1 relative">
          {idx === 0 && (
            <img
              className="w-[25px] h-[15px] absolute right-0 bottom-[-6px]"
              src={`https://static.szlcsc.com/ecp/assets/newWeb/www/home/first-icon.svg`}
              alt=""
            />
          )}
          {idx === 1 && (
            <img
              className="w-[15px] h-[18px] absolute right-0 bottom-[-6px]"
              src={`https://static.szlcsc.com/ecp/assets/newWeb/www/home/hot-icon.svg`}
              alt=""
            />
          )}
          {idx === 2 && (
            <img
              className="w-[15px] h-[15px] absolute right-0 bottom-[-6px]"
              src={`https://static.szlcsc.com/ecp/assets/newWeb/www/home/new-icon.svg`}
              alt=""
            />
          )}
        </div>
      </li>
    ));
    return (
      <section
        className="p-[20px] w-[590px] _lg:w-[766px] bg-white rounded-[20px]"
        data-spm={spmFlag}
        onClick={_buriedPoint}
        aria-label={`立创商城-首页-${title}`}
      >
        <div className="flex justify-between items-center">
          <h2 className="text-[18px] leading-[24px] font-bold">{title}</h2>
          <a
            className="hover:text-lcBlue"
            data-spm="mr"
            href={moreHref}
            title={'更多' + title}
            target="_blank"
            aria-label={`查看更多${title}`}
          >
            <RightOutlined style={{ fontSize: '14px', textWeight: 'bold' }} />
          </a>
        </div>
        <div className="flex justify-between pt-[16px]">
          <div className="mr-[26px] flex justify-between items-center hover:text-lcBlue custom-group">
            {dataList.slice(0, 1).map((item, idx) => (
              <a
                data-spm={1}
                key={idx}
                href={`${wwwUrl}/info/${item.informationId}.html`}
                target="_blank"
                title={item.title}
                className="w-[267px] _lg:w-[348px]"
              >
                {item.titleImage ? (
                  <img
                    className="w-[265px] h-[149px] _lg:w-[348px] _lg:h-[196px] rounded-[10px] border border-solid border-[#eee]"
                    src={item.titleImage}
                    alt={item.title}
                  />
                ) : (
                  <div className="text-center text-[#999] w-[265px] h-[149px] _lg:w-[348px] _lg:h-[196px] rounded-[10px] border border-solid border-[#eee] bg-[#FAFAFA] flex flex-col justify-center items-center">
                    <img
                      className="w-[82px] h-[67px] mb-[6px]"
                      src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/news-default-pic.png"
                      alt={item.title}
                    />
                    <p className="text-[14px]">暂无图片</p>
                  </div>
                )}
                <p className="mt-[16px] text-[14px] font-bold leading-[19px] truncate antialiased">{item.title}</p>
                <p className="mt-[6px] text-[14px] line-clamp-2 text-[#666666] custom-group-hover-text-lcBlue antialiased">
                  {item.intro}
                </p>
              </a>
            ))}
          </div>
          <ul className="w-[258px] _lg:w-[352px]">{listDom}</ul>
        </div>
      </section>
    );
  }
};

const BottomSection = ({ title, dataList }) => {
  const wwwUrl = Domains.lcscWwwUrl;
  const flag = title === '应用与分享' ? 'evaluate' : 'info';
  const spmFlag = title === '应用与分享' ? 'fx' : 'zx';
  const moreHref = `${wwwUrl}/${flag}/list.html`;
  const buriedOp = title === '应用与分享' ? 'application_sharing' : 'new_xx';

  function _buriedPoint() {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'index',
      op: buriedOp,
      data: {
        url: moreHref,
      },
    });
  }

  if (dataList && dataList.length) {
    return (
      <section
        data-spm={spmFlag}
        className="px-[20px] w-[590px] h-[204px] _lg:w-[766px] bg-white rounded-[20px]"
        onClick={_buriedPoint}
        aria-label={`立创商城-首页-${title}`}
      >
        <div className="pt-[20px] flex justify-between items-center">
          <h2 className="text-[18px] leading-[24px] font-bold">{title}</h2>
          <a
            data-spm="mr"
            className="hover:text-lcBlue"
            href={moreHref}
            title={'更多' + title}
            target="_blank"
            aria-label={`查看更多${title}`}
          >
            <RightOutlined style={{ fontSize: '14px', textWeight: 'bold' }} />
          </a>
        </div>
        <CustomSwiperStyle>
          <Swiper
            modules={[Pagination]}
            spaceBetween={16}
            slidesPerView={2}
            slidesPerGroup={2}
            loop
            pagination={pagination}
          >
            {dataList.map((item, idx) => (
              <SwiperSlide key={idx}>
                <a
                  data-spm={idx + 1}
                  href={`${wwwUrl}/info/${item.informationId}.html`}
                  title={item.title}
                  target="_blank"
                  className="w-[265px] _lg:w-[350px] h-[88px] mr-[22px] rounded-[8px] flex justify-between items-start hover:text-lcBlue custom-group"
                >
                  {item.titleImage ? (
                    <img
                      className="w-[106px] _lg:w-[140px] h-[72px] rounded-[8px] mr-[10px]"
                      src={item.titleImage}
                      alt={item.title}
                    />
                  ) : (
                    <div className="text-center text-[#999] w-[106px] _lg:w-[140px] h-[72px] rounded-[8px] mr-[10px] bg-[#FAFAFA] flex flex-col justify-center items-center border border-solid border-[#eee]">
                      <img
                        className="w-[31px] h-[25px] mb-[4px]"
                        src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/news-default-pic.png"
                        alt={item.title}
                      />
                      <p className="text-[10px]">暂无图片</p>
                    </div>
                  )}
                  <div className="w-[150px] _lg:w-[195px]">
                    <p className="text-[14px] font-bold leading-[19px] truncate">{item.title}</p>
                    <p className="line-clamp-3 text-[14px] text-[#666666] mt-[6px] custom-group-hover-text-lcBlue">
                      {item.intro}
                    </p>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </CustomSwiperStyle>
      </section>
    );
  }
};

const IndexInformationArea = ({ isLgScreen, data }) => {
  if (data) {
    return (
      <section className="mx-auto w-[1200px] _lg:w-[1552px] mt-[20px]">
        <div className="flex justify-between items-center">
          <TopSection title="推荐供应商" dataList={data?.supplierInfoList} isLgScreen={isLgScreen}></TopSection>
          <TopSection title="新品推荐" dataList={data?.recommendInfoList} isLgScreen={isLgScreen}></TopSection>
        </div>
        <div className="mt-[20px] flex justify-between items-center">
          <BottomSection title="行业资讯" dataList={data?.industryInformationList}></BottomSection>
          <BottomSection title="应用与分享" dataList={data?.evaluateInfoList}></BottomSection>
        </div>
      </section>
    );
  }
};

export default IndexInformationArea;
